
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightRoofColourOff as ObiLightRoofColourOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-roof-colour-off.js';
 
 
 

 
 export const ObiLightRoofColourOff = createComponent({
   react: React,
   tagName: 'obi-light-roof-colour-off',
   elementClass: ObiLightRoofColourOffElement,
   events: {
     
   }
  });
 
 